import { PlusIcon } from "lucide-react";

import { Link } from "@/components/Link";
import type { TestResult } from "../../types";
import { usePersistedAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TableFilterRow } from "../TableFilterRow";

export function OrganismsTable({
  organisms,
}: {
  organisms: TestResult[] | undefined;
}) {
  const { options, filterTextProps } = usePersistedAdminGridOptions(
    "organisms",
    organisms,
    [
      {
        field: "description",
        headerName: "Name",
        filter: "agTextColumnFilter",
        cellRenderer: (params) => (
          <Link
            to="/admin/results/$id/edit"
            params={{ id: encodeURIComponent(params.id) }}
          >
            {params.description}
          </Link>
        ),
        cellRendererParams: (params) => ({
          description: params.data.description,
          id: params.data.value,
        }),
      },
      {
        field: "value",
        headerName: "Code",
        filter: "agTextColumnFilter",
      },
    ],
    { sideBar: undefined },
  );

  return (
    <>
      <TableFilterRow inputProps={filterTextProps}>
        <Link
          to="/admin/results/new"
          // biome-ignore lint/suspicious/noExplicitAny: category search param not in route types
          search={{ category: "ORGANISM" } as any}
          asButton
        >
          <PlusIcon data-slot="icon" />
          Add organism
        </Link>
      </TableFilterRow>
      <AdminGrid {...options} />
    </>
  );
}
